import { useEffect, useRef } from "react";
import { Link } from 'react-router-dom'
import $ from "jquery";
import jszip from "jszip";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.vfs;

const RolesManagement = () => {

    const table1 = useRef(null);
    const table2 = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        let table11, table12

        if (table1.current) {
            table11 = $(table1.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }
        if (table2.current) {
            table12 = $(table2.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }
        return () => {
            if (table11) table11.destroy();
            if (table12) table12.destroy();
        };
    }, []);

    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Role Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Role Management</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="card">
                        <div className="card-body">
                            <ul className="nav nav-tabs mb-3" id="categoryTabs" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="active-cat-tab" data-bs-toggle="tab" data-bs-target="#activeCategories" type="button" role="tab">Roles </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="inactive-cat-tab" data-bs-toggle="tab" data-bs-target="#inactiveCategories" type="button" role="tab">Users</button>
                                </li>
                            </ul>
                            <div className="tab-content" id="categoryTabsContent">
                                <div className="tab-pane fade show active" id="activeCategories" role="tabpanel">
                                    <div className="text-end">
                                        <button className="btn btn-primary Create-btn" data-bs-toggle="modal" data-bs-target="#createCategoryModal">
                                            <i className="bx bx-plus" /> Create
                                        </button>
                                    </div>
                                    <div className="card radius-10 w-100">
                                        <div className="card-body categr-btn">
                                            <div className="table-responsive">
                                                <div className="entries-wrapper mb-3">
                                                    <label className="entries-label">
                                                        <span>Showing</span>
                                                        <select className="entries-select">
                                                            <option value={10} selected>10</option>
                                                            <option value={25}>25</option>
                                                            <option value={50}>50</option>
                                                            <option value={100}>100</option>
                                                        </select>
                                                        <span>Entries</span>
                                                    </label>
                                                </div>
                                                <table ref={table1} className="table table-striped table-bordered align-middle">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th>Role Name</th>
                                                            <th>User Count</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>Administrator</td>
                                                            <td>5</td>
                                                            <td>
                                                                <ul className="tbl_actions_wrap d-flex gap-2 list-unstyled mb-0">
                                                                    <li><Link to="#" data-bs-toggle="modal" data-bs-target="#editCategoryModal" title="Edit"><i className="bx bx-edit" /></Link></li>
                                                                    <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteCategoryModal" title="Delete"><i className="bx bx-trash" /></Link>
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Vendor</td>
                                                            <td>12</td>
                                                            <td>
                                                                <ul className="tbl_actions_wrap d-flex gap-2 list-unstyled mb-0">
                                                                    <li><Link to="#" data-bs-toggle="modal" data-bs-target="#editCategoryModal" title="Edit"><i className="bx bx-edit" /></Link></li>
                                                                    <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteCategoryModal" title="Delete"><i className="bx bx-trash" /></Link>
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>owner</td>
                                                            <td>30</td>
                                                            <td>
                                                                <ul className="tbl_actions_wrap d-flex gap-2 list-unstyled mb-0">
                                                                    <li><Link to="#" data-bs-toggle="modal" data-bs-target="#editCategoryModal" title="Edit"><i className="bx bx-edit" /></Link></li>
                                                                    <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteCategoryModal" title="Delete"><i className="bx bx-trash" /></Link>
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Support Staff</td>
                                                            <td>8</td>
                                                            <td>
                                                                <ul className="tbl_actions_wrap d-flex gap-2 list-unstyled mb-0">
                                                                    <li><Link to="#" data-bs-toggle="modal" data-bs-target="#editCategoryModal" title="Edit"><i className="bx bx-edit" /></Link></li>
                                                                    <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteCategoryModal" title="Delete"><i className="bx bx-trash" /></Link>
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="inactiveCategories" role="tabpanel">
                                    <div className="text-end">
                                        <button className="btn btn-primary Create-btn" data-bs-toggle="modal" data-bs-target="#createUserModal">
                                            <i className="bx bx-plus" /> Create
                                        </button>
                                    </div>
                                    <div className="card radius-10 w-100">
                                        <div className="card-body categr-btn">
                                            <div className="table-responsive">
                                                <div className="entries-wrapper mb-3">
                                                    <label className="entries-label">
                                                        <span>Showing</span>
                                                        <select className="entries-select">
                                                            <option value={10} selected>10</option>
                                                            <option value={25}>25</option>
                                                            <option value={50}>50</option>
                                                            <option value={100}>100</option>
                                                        </select>
                                                        <span>Entries</span>
                                                    </label>
                                                </div>
                                                <table ref={table2} className="table table-striped table-bordered align-middle">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th>User Name</th>
                                                            <th>Email</th>
                                                            <th>Phone Number</th>
                                                            <th>Role</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>Ella Roberts</td>
                                                            <td>ella.roberts@example.com</td>
                                                            <td>+1 202-555-0147</td>
                                                            <td>Administrator</td>
                                                            <td>
                                                                <ul className="tbl_actions_wrap d-flex gap-2 list-unstyled mb-0">
                                                                    <li>
                                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#editUserModal" title="Edit Access">
                                                                            <i className="bx bx-edit" />
                                                                        </Link>
                                                                    </li>
                                                                    <li>
                                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#blockUserModal" title="Block User">
                                                                            <i className="bx bx-block" />
                                                                        </Link>
                                                                    </li>
                                                                    <li>
                                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#deleteUserModal" title="Delete User">
                                                                            <i className="bx bx-trash" />
                                                                        </Link>
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Lucas Martinez</td>
                                                            <td>lucas.m@example.com</td>
                                                            <td>+44 7400 555123</td>
                                                            <td>Vendor</td>
                                                            <td>
                                                                <ul className="tbl_actions_wrap d-flex gap-2 list-unstyled mb-0">
                                                                    <li>
                                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#editUserModal" title="Edit Access">
                                                                            <i className="bx bx-edit" />
                                                                        </Link>
                                                                    </li>
                                                                    <li>
                                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#blockUserModal" title="Block User">
                                                                            <i className="bx bx-block" />
                                                                        </Link>
                                                                    </li>
                                                                    <li>
                                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#deleteUserModal" title="Delete User">
                                                                            <i className="bx bx-trash" />
                                                                        </Link>
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Sophia Lee</td>
                                                            <td>sophia.lee@example.com</td>
                                                            <td>+61 400 555 987</td>
                                                            <td>owner</td>
                                                            <td>
                                                                <ul className="tbl_actions_wrap d-flex gap-2 list-unstyled mb-0">
                                                                    <li>
                                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#editUserModal" title="Edit Access">
                                                                            <i className="bx bx-edit" />
                                                                        </Link>
                                                                    </li>
                                                                    <li>
                                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#blockUserModal" title="Block User">
                                                                            <i className="bx bx-block" />
                                                                        </Link>
                                                                    </li>
                                                                    <li>
                                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#deleteUserModal" title="Delete User">
                                                                            <i className="bx bx-trash" />
                                                                        </Link>
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>William Carter</td>
                                                            <td>will.carter@example.com</td>
                                                            <td>+1 310-555-2345</td>
                                                            <td>Support Staff</td>
                                                            <td>
                                                                <ul className="tbl_actions_wrap d-flex gap-2 list-unstyled mb-0">
                                                                    <li>
                                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#editUserModal" title="Edit Access">
                                                                            <i className="bx bx-edit" />
                                                                        </Link>
                                                                    </li>
                                                                    <li>
                                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#blockUserModal" title="Block User">
                                                                            <i className="bx bx-block" />
                                                                        </Link>
                                                                    </li>
                                                                    <li>
                                                                        <Link to="#" data-bs-toggle="modal" data-bs-target="#deleteUserModal" title="Delete User">
                                                                            <i className="bx bx-trash" />
                                                                        </Link>
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="createCategoryModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Create new role</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="create_noti_form">
                                <form>
                                    <div className="col-md-12">
                                        <label htmlFor="input1" className="form-label">Role name</label>
                                        <input type="name" className="form-control" id="input2" />
                                    </div>
                                    <div className="col-md-12 mt-3">
                                        <label htmlFor="input1" className="form-label">Rights</label>
                                        <div className="right-list">
                                            <ul>
                                                <li>
                                                    <span className="list-switch">Dashboard</span>
                                                    <div className="row switch-main active">
                                                        <div className="col-lg-3 col-md-3">
                                                            <label className="switch">
                                                                <input type="checkbox" />
                                                                <span className="slider round" />
                                                            </label>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9">
                                                            <div className="check-role">
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="view11" />
                                                                    <label htmlFor="view11">view</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="delete11" />
                                                                    <label htmlFor="delete11">Delete</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className="list-switch">Coach Management</span>
                                                    <div className="row switch-main">
                                                        <div className="col-lg-3 col-md-3">
                                                            <label className="switch">
                                                                <input type="checkbox" />
                                                                <span className="slider round" />
                                                            </label>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9">
                                                            <div className="check-role">
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="sellerview11" />
                                                                    <label htmlFor="sellerview11">view</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="selleredit11" />
                                                                    <label htmlFor="selleredit11">Send</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className="list-switch">Games Management</span>
                                                    <div className="row switch-main active">
                                                        <div className="col-lg-3 col-md-3">
                                                            <label className="switch">
                                                                <input type="checkbox" />
                                                                <span className="slider round" />
                                                            </label>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9">
                                                            <div className="check-role">
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="Productview11" />
                                                                    <label htmlFor="Productview11">view</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="Productedit11" />
                                                                    <label htmlFor="Productedit11">Reschedule</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="Productdel11" />
                                                                    <label htmlFor="Productdel11">Delete</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className="list-switch">Teams Management</span>
                                                    <div className="row switch-main">
                                                        <div className="col-lg-3 col-md-3">
                                                            <label className="switch">
                                                                <input type="checkbox" />
                                                                <span className="slider round" />
                                                            </label>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9">
                                                            <div className="check-role">
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="Orderview11" />
                                                                    <label htmlFor="Orderview11">view</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="Orderedit11" />
                                                                    <label htmlFor="Orderedit11">edit</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="Orderdel11" />
                                                                    <label htmlFor="Orderdel11">Delete</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className="list-switch">Payments</span>
                                                    <div className="row switch-main active">
                                                        <div className="col-lg-3 col-md-3">
                                                            <label className="switch">
                                                                <input type="checkbox" />
                                                                <span className="slider round" />
                                                            </label>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9">
                                                            <div className="check-role">
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="Managementview11" />
                                                                    <label htmlFor="Managementview11">view</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="Managementedit11" />
                                                                    <label htmlFor="Managementedit11">Download</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className="list-switch">Role Management</span>
                                                    <div className="row switch-main">
                                                        <div className="col-lg-3 col-md-3">
                                                            <label className="switch">
                                                                <input type="checkbox" />
                                                                <span className="slider round" />
                                                            </label>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9">
                                                            <div className="check-role">
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="marketingview11" />
                                                                    <label htmlFor="marketingview11">view</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="marketingedit11" />
                                                                    <label htmlFor="marketingedit11">edit</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="marketingdel11" />
                                                                    <label htmlFor="marketingdel11">Delete</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className="list-switch">Notifications &amp; Emails</span>
                                                    <div className="row switch-main active">
                                                        <div className="col-lg-3 col-md-3">
                                                            <label className="switch">
                                                                <input type="checkbox" />
                                                                <span className="slider round" />
                                                            </label>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9">
                                                            <div className="check-role">
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="paymentview11" />
                                                                    <label htmlFor="paymentview11">view</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="paymentedit11" />
                                                                    <label htmlFor="paymentedit11">edit</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="notisend11" />
                                                                    <label htmlFor="notisend11">Send</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="paymentdel11" />
                                                                    <label htmlFor="paymentdel11">Delete</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className="list-switch">Settings</span>
                                                    <div className="row switch-main">
                                                        <div className="col-lg-3 col-md-3">
                                                            <label className="switch">
                                                                <input type="checkbox" />
                                                                <span className="slider round" />
                                                            </label>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9">
                                                            <div className="check-role">
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="paymentview11" />
                                                                    <label htmlFor="paymentview11">view</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="paymentedit11" />
                                                                    <label htmlFor="paymentedit11">edit</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="paymentdel11" />
                                                                    <label htmlFor="paymentdel11">edit</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">save</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="deleteCategoryModal" tabIndex={-1}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirmation alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <h5>Do you want to delete this category?</h5>
                        </div>
                        <div className="modal-footer modal-center">
                            <button className="btn btn-secondary">Yes</button>
                            <button className="btn btn-primary" data-bs-dismiss="modal">No</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="editCategoryModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Edit</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="create_noti_form">
                                <form>
                                    <div className="col-md-12">
                                        <label htmlFor="input1" className="form-label">Role name</label>
                                        <input type="name" className="form-control" id="input2" />
                                    </div>
                                    <div className="col-md-12 mt-3">
                                        <label htmlFor="input1" className="form-label">Rights</label>
                                        <div className="right-list">
                                            <ul>
                                                <li>
                                                    <span className="list-switch">Dashboard</span>
                                                    <div className="row switch-main active">
                                                        <div className="col-lg-3 col-md-3">
                                                            <label className="switch">
                                                                <input type="checkbox" />
                                                                <span className="slider round" />
                                                            </label>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9">
                                                            <div className="check-role">
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="view1" />
                                                                    <label htmlFor="view1">view</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className="list-switch">Coach Management</span>
                                                    <div className="row switch-main">
                                                        <div className="col-lg-3 col-md-3">
                                                            <label className="switch">
                                                                <input type="checkbox" />
                                                                <span className="slider round" />
                                                            </label>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9">
                                                            <div className="check-role">
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="sellerview1" />
                                                                    <label htmlFor="sellerview1">view</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="sellerinvite1" />
                                                                    <label htmlFor="sellerinvite1">Invite</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="selleredit1" />
                                                                    <label htmlFor="selleredit1">Send</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className="list-switch">Games Management</span>
                                                    <div className="row switch-main active">
                                                        <div className="col-lg-3 col-md-3">
                                                            <label className="switch">
                                                                <input type="checkbox" />
                                                                <span className="slider round" />
                                                            </label>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9">
                                                            <div className="check-role">
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="Productview1" />
                                                                    <label htmlFor="Productview1">view</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="Productcreate1" />
                                                                    <label htmlFor="Productcreate1">Create</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="Productedit1" />
                                                                    <label htmlFor="Productedit1">Reschedule</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="Productdel1" />
                                                                    <label htmlFor="Productdel1">Delete</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className="list-switch">Teams Management</span>
                                                    <div className="row switch-main">
                                                        <div className="col-lg-3 col-md-3">
                                                            <label className="switch">
                                                                <input type="checkbox" />
                                                                <span className="slider round" />
                                                            </label>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9">
                                                            <div className="check-role">
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="Orderview1" />
                                                                    <label htmlFor="Orderview1">view</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="Ordercreate1" />
                                                                    <label htmlFor="Ordercreate1">Create</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="Orderedit1" />
                                                                    <label htmlFor="Orderedit1">edit</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="Orderdel1" />
                                                                    <label htmlFor="Orderdel1">Delete</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className="list-switch">Payments</span>
                                                    <div className="row switch-main active">
                                                        <div className="col-lg-3 col-md-3">
                                                            <label className="switch">
                                                                <input type="checkbox" />
                                                                <span className="slider round" />
                                                            </label>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9">
                                                            <div className="check-role">
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="Managementview1" />
                                                                    <label htmlFor="Managementview1">view</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="Managementedit1" />
                                                                    <label htmlFor="Managementedit1">Download</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className="list-switch">Role Management</span>
                                                    <div className="row switch-main">
                                                        <div className="col-lg-3 col-md-3">
                                                            <label className="switch">
                                                                <input type="checkbox" />
                                                                <span className="slider round" />
                                                            </label>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9">
                                                            <div className="check-role">
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="marketingview1" />
                                                                    <label htmlFor="marketingview1">view</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="marketingedit1" />
                                                                    <label htmlFor="marketingedit1">edit</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="marketingdel1" />
                                                                    <label htmlFor="marketingdel1">Delete</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className="list-switch">Notifications &amp; Emails</span>
                                                    <div className="row switch-main active">
                                                        <div className="col-lg-3 col-md-3">
                                                            <label className="switch">
                                                                <input type="checkbox" />
                                                                <span className="slider round" />
                                                            </label>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9">
                                                            <div className="check-role">
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="paymentview1" />
                                                                    <label htmlFor="paymentview1">view</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="paymentedit1" />
                                                                    <label htmlFor="paymentedit1">edit</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="notisend1" />
                                                                    <label htmlFor="notisend1">Send</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="paymentdel1" />
                                                                    <label htmlFor="paymentdel1">Delete</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <span className="list-switch">Settings</span>
                                                    <div className="row switch-main">
                                                        <div className="col-lg-3 col-md-3">
                                                            <label className="switch">
                                                                <input type="checkbox" />
                                                                <span className="slider round" />
                                                            </label>
                                                        </div>
                                                        <div className="col-lg-9 col-md-9">
                                                            <div className="check-role">
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="paymentview1" />
                                                                    <label htmlFor="paymentview1">view</label>
                                                                </div>
                                                                <div className="form-group1">
                                                                    <input type="checkbox" id="paymentedit1" />
                                                                    <label htmlFor="paymentedit1">edit</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Save</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="createUserModal" tabIndex={-1}>
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Create New User</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="row mb-3 align-items-center">
                                    <div className="col-md-3">
                                        <h6 className="mb-0">User Name</h6>
                                    </div>
                                    <div className="col-md-9 text-secondary">
                                        <input type="text" className="form-control" placeholder="Enter name" />
                                    </div>
                                </div>
                                <div className="row mb-3 align-items-center">
                                    <div className="col-md-3">
                                        <h6 className="mb-0">Email</h6>
                                    </div>
                                    <div className="col-md-9 text-secondary">
                                        <input type="email" className="form-control" placeholder="Enter email" />
                                    </div>
                                </div>
                                <div className="row mb-3 align-items-center">
                                    <div className="col-md-3">
                                        <h6 className="mb-0">Phone Number</h6>
                                    </div>
                                    <div className="col-md-9 text-secondary">
                                        <input type="text" className="form-control" placeholder="Enter phone number" />
                                    </div>
                                </div>
                                <div className="row mb-3 align-items-center">
                                    <div className="col-md-3">
                                        <h6 className="mb-0">Role</h6>
                                    </div>
                                    <div className="col-md-9 text-secondary">
                                        <select className="form-control">
                                            <option selected disabled>Select Role</option>
                                            <option>Administrator</option>
                                            <option>Vendor</option>
                                            <option>owner</option>
                                            <option>Support Staff</option>
                                        </select>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-primary">Create User</button>
                            <button className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="editUserModal" tabIndex={-1}>
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Edit User Access</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="row mb-3 align-items-center">
                                    <div className="col-md-3">
                                        <h6 className="mb-0">User Name</h6>
                                    </div>
                                    <div className="col-md-9 text-secondary">
                                        <input type="text" className="form-control" placeholder="Enter user name" />
                                    </div>
                                </div>
                                <div className="row mb-3 align-items-center">
                                    <div className="col-md-3">
                                        <h6 className="mb-0">Email</h6>
                                    </div>
                                    <div className="col-md-9 text-secondary">
                                        <input type="email" className="form-control" placeholder="Enter email" />
                                    </div>
                                </div>
                                <div className="row mb-3 align-items-center">
                                    <div className="col-md-3">
                                        <h6 className="mb-0">Phone Number</h6>
                                    </div>
                                    <div className="col-md-9 text-secondary">
                                        <input type="text" className="form-control" placeholder="Enter phone number" />
                                    </div>
                                </div>
                                <div className="row mb-3 align-items-center">
                                    <div className="col-md-3">
                                        <h6 className="mb-0">Role</h6>
                                    </div>
                                    <div className="col-md-9 text-secondary">
                                        <select className="form-control">
                                            <option>Administrator</option>
                                            <option>Vendor</option>
                                            <option>owner</option>
                                            <option>Support Staff</option>
                                        </select>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-primary">Save </button>
                            <button className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="blockUserModal" tabIndex={-1}>
                <div className="modal-dialog modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirmation alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <h5>Are you sure you want to block this user?</h5>
                        </div>
                        <div className="modal-footer modal-center">
                            <button className="btn btn-secondary">Yes</button>
                            <button className="btn btn-primary" data-bs-dismiss="modal">No</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="deleteUserModal" tabIndex={-1}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirmation alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <h5>Do you want to delete this user?</h5>
                        </div>
                        <div className="modal-footer modal-center">
                            <button className="btn btn-secondary">Yes</button>
                            <button className="btn btn-primary" data-bs-dismiss="modal">No</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RolesManagement